import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AuthguardGuard } from '../../core/guards/authguard.guard';
import { DashComponent } from './components/dash/dash.component';
import { AdminComponent } from './components/admin/admin.component';
import { Dash2Component } from './components/dash2/dash2.component';
import { DetailsComponent } from './components/details/details.component';
import { SaLogsComponent } from './components/sa-logs/sa-logs.component';
import { SaHelpVideoComponent } from './components/sa-help-video/sa-help-video.component';
import { PaypalTransactionHistoryComponent } from './components/paypal-transaction-history/paypal-transaction-history.component';
import { SaPaypalInvoiceDetailsComponent } from './components/sa-paypal-invoice-details/sa-paypal-invoice-details.component';
import { PaypalPromocodeComponent } from './components/paypal-promocode/paypal-promocode.component';
import { IpsTransactionHistoryComponent } from './components/ips-transaction-history/ips-transaction-history.component';
import { SaIpsInvoiceDetailsComponent } from './components/sa-ips-invoice-details/sa-ips-invoice-details.component';
import { TransactionHistoryCombinedComponent } from './components/transaction-history-combined/transaction-history-combined.component';
import { NgModule } from '@angular/core';


export const SaRoutes: Routes = [

    {
        path: 'Home',
        canActivate: [AuthguardGuard],
        data: { roles: ['SA'] },
        component: HomeComponent,
        children: [

            {
                path: 'dash',
                component: DashComponent
            },
            {
                path: 'admin',
                component: AdminComponent
            },
            // {
            //   path: 'license',
            //   component: LicenseComponent
            // },
            {
                path: 'dash2',
                component: Dash2Component
            },
            {
                path: 'details',
                component: DetailsComponent
            },

            {
                path: 'SaHelpVideo',
                component: SaHelpVideoComponent

            },
            {
                path: 'PaypalTransactionHistory',
                component: PaypalTransactionHistoryComponent

            },
            {
                path: 'IpsTransactionHistory',
                component: IpsTransactionHistoryComponent

            },
            {
                path: 'SaIpsInvoiceDetails',
                component: SaIpsInvoiceDetailsComponent

            },

            {
                path: 'SaPaypalInvoiceDetails',
                component: SaPaypalInvoiceDetailsComponent

            },
            {
                path: 'PaypalPromocode',
                component: PaypalPromocodeComponent

            },

            {
                path: 'TransactionHistory',
                component: TransactionHistoryCombinedComponent

            },



            {
                path: 'Logs',
                component: SaLogsComponent
            },
            {
                path: '',
                redirectTo: 'dash',
                pathMatch: 'full'

            }
        ]
    }
]




@NgModule({
    imports: [RouterModule.forChild(SaRoutes)],
    exports: [RouterModule],
    
  


})

export class SaRoutingModule { };
